<template lang="pug">
  section(:style="`height: ${height};`")
    TransitionLogo(:size="size", :text="text")
    ArrowButton.arrow
</template>
<script>

import TransitionLogo from '@/components/transition/TransitionLogo'
import ArrowButton from '@/components/transition/ArrowButton'

export default {
  props: {
    size: {
      type: String,
      default: '10rem'
    },
    text: {
      type: String,
      default: 'Transition'
    },
    height: {
      type: String,
      default: '100vh'
    }
  },
  components: {
    TransitionLogo,
    ArrowButton
  },
}
</script>

<style lang="scss" scoped>
  section{
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    @media (max-width: 800px){
      height: 90vh;
    }
    .arrow{
      position: absolute;
      bottom: 10vh;
    }
  }
</style>

